"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const SpaHeaderStyle = (0, styled_components_1.createGlobalStyle) `
  .spa-header__overlay {
    min-height: 150px;
    background-color: #1c49c2;
    position: relative;
    width: 100%;
    box-sizing: border-box;
  }
  .spa-header__overlay.spa-header__overlay--eyebrow {
    min-height: 191px;
  }

  .spa-header__overlay--eyebrow {
    background: linear-gradient(
      to bottom,
      #1c49c2 calc(100% - 41px),
      #ffffff 41px
    );
  }

  @media (max-width: 750px) {
    .spa-header__overlay {
      min-height: 43px;
      padding-top: 5rem;
    }
    .spa-header__overlay.spa-header__overlay--eyebrow {
      min-height: 120px;
    }
  }
  .spa-minimal-header__overlay {
    min-height: 105px;
  }
  .spa-minimal-header__overlay.spa-header__overlay--eyebrow {
    min-height: 146px;
  }
  @media (max-width: 750px) {
    .spa-minimal-header__overlay {
      min-height: 45px;
    }
    .spa-minimal-header__overlay.spa-header__overlay--eyebrow {
      min-height: 72px;
    }
  }
`;
exports.default = SpaHeaderStyle;
//# sourceMappingURL=spa-header-style.js.map